module.exports = __webpack_public_path__ + "img/icon-competence-8.3ebf0da1.svg";